import { EnumConfigEmpresa } from "models/enums/enum-config-empresa";
import { useCallback, useMemo } from "react"
import { useCardapioDadosStore } from "services/store/cardapio-dados-store";

export const useEmpresaAtual = () => {
    const cardapioDados = useCardapioDadosStore(state => state.cardapioDados);
    const configuracoesEmpresa = useMemo(() => cardapioDados?.configuracoesEmpresa ?? [], [cardapioDados]);

    const getConfigByCod = useCallback((cod: EnumConfigEmpresa) => {
        return configuracoesEmpresa.find((item) => item.codigo === cod);
    }, [configuracoesEmpresa])

    const getEmpresaAtual = useCallback(() => {
        return cardapioDados?.empresa;
    }, [cardapioDados?.empresa])

    return {
        getConfigByCod,
        getEmpresaAtual
    }
}